import React, { Component } from 'react';
import PropTypes from 'prop-types';

import AgGridTableContainer from '../../../table/ag-grid-table-container';
import { reportsCustomGridOptions, TABLE_TYPES } from '../../../table/constants/table-options';
import { formatDate } from '../../../utils/common-utils';

export class DmarcAuthTable extends Component{
    buildColumns = () => {
        const { interval } = this.props;
        return [
            {
                field: 'date',
                headerName: 'Date',
                valueFormatter: ( params ) => formatDate( params.value, interval )
            },
            {
                field: 'passCount',
                headerName: 'Messages Passing DMARC',
                type: [
                    'numberColumn',
                    'rightAlignColumn'
                ],
            },
            {
                field: 'passRate',
                headerName: 'DMARC Pass Rate (% of total msg)',
                type: [
                    'rateColumn',
                    'rightAlignColumn'
                ],
            },
            {
                field: 'failCount',
                headerName: 'Messages Failing DMARC',
                type: [
                    'numberColumn',
                    'rightAlignColumn'
                ],
            },
            {
                field: 'failRate',
                headerName: 'DMARC Fail Rate (% of total msg)',
                type: [
                    'rateColumn',
                    'rightAlignColumn'
                ],
            },
            {
                field: 'total',
                headerName: 'Total Messages',
                type: [
                    'numberColumn',
                    'rightAlignColumn'
                ],
            }
        ];
    };

    render(){
        const { data, isExportingGridToCSV, exportToCSVSuccess, exportToCSVFailure } = this.props;

        return (
            <AgGridTableContainer
                columnDefs={this.buildColumns()}
                customGridOptions={reportsCustomGridOptions}
                dataAutomationId="reports-dmarc-authentication-table"
                exportCSVFileName="DomainProgressA"
                exportToCSVFailure={exportToCSVFailure}
                exportToCSVSuccess={exportToCSVSuccess}
                isExportingGridToCSV={isExportingGridToCSV}
                tableType={`${TABLE_TYPES.BASIC} ${TABLE_TYPES.REPORTING}`}
                rowData={data}
                widgetId="authentication"
            />
        );
    };
};

DmarcAuthTable.propTypes = {
    data: PropTypes.array,
    exportToCSVFailure: PropTypes.func,
    exportToCSVSuccess: PropTypes.func,
    interval: PropTypes.string,
    isExportingGridToCSV: PropTypes.bool,
};

export default DmarcAuthTable;
